import { jsxs as n, jsx as l } from "react/jsx-runtime";
const t = ({
  width: e,
  height: o,
  className: i
}) => /* @__PURE__ */ n(
  "svg",
  {
    className: i,
    fill: "none",
    height: o,
    viewBox: "0 0 14 14",
    width: e,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l(
        "circle",
        {
          cx: "7",
          cy: "7",
          fill: "currentColor",
          r: "7"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.10036 4.33301C7.43993 4.33301 7.71521 4.60829 7.71521 4.94787V6.48501H9.25236C9.59193 6.48501 9.86722 6.76029 9.86722 7.09987C9.86722 7.43944 9.59193 7.71473 9.25236 7.71473H7.71521V9.25187C7.71521 9.59145 7.43993 9.86673 7.10036 9.86673C6.76078 9.86673 6.4855 9.59145 6.4855 9.25187V7.71473H4.94835C4.60878 7.71473 4.3335 7.43944 4.3335 7.09987C4.3335 6.76029 4.60878 6.48501 4.94835 6.48501H6.4855V4.94787C6.4855 4.60829 6.76078 4.33301 7.10036 4.33301Z",
          fill: "white",
          fillRule: "evenodd"
        }
      )
    ]
  }
);
export {
  t as Content
};
